/**
 *
 * Hikos Env
 *
 */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  generatePath,
  Redirect,
  Route,
  RouteComponentProps,
  Switch,
} from 'react-router-dom';
import { IRouteWithEnvIdParams } from 'types';
import PrivateRoute from 'utils/PrivateRoute';
import { RouteConstants } from '../../routes';
import { Cultures } from '../Cultures';
import { Company } from '../Company';
import { Task } from '../Task';
import { User } from '../User';
import { Field } from '../Field';
import { useHiikoEnvSlice } from './slice';
import { selectEnvs, selectSelectedEnvId } from './slice/selectors';
import SeasonWrapper from '../Season/parts/SeasonWrapper/SeasonWrapper';
import { useCompanySlice } from '../Company/slice';
import { Resource } from '../Resource';
import { Meteo } from '../Meteo';
import { Analytics } from '../Analytics';
import Settings from '../Settings';
import Garage from '../Garage';
import Recipe from '../Recipe';
import useGetPermissions from 'utils/hooks/useGetPermissions';

interface IProps extends RouteComponentProps<IRouteWithEnvIdParams> {}

export function HiikoEnv({ match: { params }, history }: IProps) {
  const envId = useSelector(selectSelectedEnvId);
  const envs = useSelector(selectEnvs);
  const dispatch = useDispatch();
  const { actions } = useHiikoEnvSlice();
  const { actions: companyActions } = useCompanySlice();

  useEffect(() => {
    const envIdInUrl = Number(params.envId);

    if (envId !== envIdInUrl) {
      const isValidEnvId = envs.find(envInList => envInList.id === envIdInUrl);
      if (isValidEnvId) {
        dispatch(companyActions.setSelectedCompanyGroupId(null));
        dispatch(actions.setSelectedEnvId(envIdInUrl));
        dispatch(companyActions.getCompanies(envIdInUrl));
      } else {
        history.push(RouteConstants.hiikoEnv.list);
      }
    }
  }, [envId, params, actions, dispatch, history, envs, companyActions]);

  const isPermissionsLoaded = useGetPermissions();

  if (!envId || !isPermissionsLoaded) {
    return null;
  }

  return (
    <SeasonWrapper>
      <Switch>
        <PrivateRoute
          path={RouteConstants.cultures.index}
          component={Cultures}
        />
        <PrivateRoute path={RouteConstants.company.index} component={Company} />
        <PrivateRoute
          path={RouteConstants.settings.index}
          component={Settings}
        />
        <PrivateRoute path={RouteConstants.task.index} component={Task} />
        <PrivateRoute path={RouteConstants.user.index} component={User} />
        <PrivateRoute path={RouteConstants.field.index} component={Field} />
        <PrivateRoute path={RouteConstants.meteo.index} component={Meteo} />
        <PrivateRoute
          path={RouteConstants.resource.index}
          component={Resource}
        />
        <PrivateRoute
          path={RouteConstants.usedResource.index}
          component={Resource}
        />
        <PrivateRoute
          path={RouteConstants.analytics.index}
          component={Analytics}
        />
        <PrivateRoute path={RouteConstants.garage.index} component={Garage} />
        <PrivateRoute path={RouteConstants.recipe.index} component={Recipe} />

        {/* <Route component={NotFoundPage} /> */}
        {/* TODO: remove Redirect below */}

        <Route
          exact
          path={RouteConstants.company.index}
          render={props => (
            <Redirect
              to={generatePath(RouteConstants.company.list, {
                envId: Number(props.match.params.envId),
              })}
            />
          )}
        />
      </Switch>
    </SeasonWrapper>
  );
}
